<script lang="ts" context="module">
  export enum Size {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
  }
</script>

<script lang="ts">
  export let color: string = 'white';
  export let size: Size = Size.Medium;
</script>

<div class="loader" style:color class:large={size === Size.Large} class:small={size === Size.Small}>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
  <div></div>
</div>

<style lang="scss">

  .loader,
  .loader > div {
    position: relative;
    box-sizing: border-box;
  }

  .loader {
    display: block;
    font-size: 0;
    width: 100%;
    height: 32px;
  }

  .loader > div {
    display: inline-block;
    float: none;
    background-color: currentColor;
    border: 0 solid currentColor;
    width: 4px;
    height: 30px;
    margin: 2px;
    margin-top: 0;
    margin-bottom: 0;
    border-radius: 0;
    animation: pulse 0.9s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78);
  }

  .loader > div:nth-child(3) {
    animation-delay: -0.9s;
  }
  .loader > div:nth-child(2),
  .loader > div:nth-child(4) {
    animation-delay: -0.65s;
  }
  .loader > div:nth-child(1),
  .loader > div:nth-child(5) {
    animation-delay: -0.4s;
  }

  @keyframes pulse {
    0% {
      transform: scaley(1);
    }
    80% {
      transform: scaley(0.3);
    }
    90% {
      transform: scaley(1);
    }
  }

  .small {
    height: 16px;
  }

  .small > div {
    width: 2px;
    height: 16px;
    margin: 1px;
    margin-top: 0;
    margin-bottom: 0;
  }

  .large {
    width: 80px;
    height: 64px;
  }

  .large > div {
    width: 8px;
    height: 64px;
    margin: 4px;
    margin-top: 0;
    margin-bottom: 0;
  }
</style>
